export enum ExportDataEnum {
  OWNER='OWNER',
  PEER = 'PEER',
  SME_OWNER = 'SME OWNER',
  SME_PEER ='SME PEER'
}
